(function () {
  'use strict';

  if (window.innerWidth > 768) return;

  function override() {
    if (!window.InstafeedAPI || !InstafeedAPI.sliderMove) return false;

    var origSliderMove = InstafeedAPI.sliderMove;

    InstafeedAPI.sliderMove = function (direction, feedId) {
      var container = document.querySelector(
        '.instafeed-new-layout-container[data-feed-id="' + feedId + '"]'
      );
      if (!container) return origSliderMove.call(this, direction, feedId);

      var wrapper = container.querySelector('.instafeed-new-layout-wrapper');
      if (!wrapper) return origSliderMove.call(this, direction, feedId);

      var item = wrapper.querySelector('.instafeed-new-layout-item');
      var gap = parseFloat(getComputedStyle(wrapper).gap) || 2;
      var scrollAmount = item ? item.offsetWidth + gap : window.innerWidth * 0.62;

      wrapper.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      });
    };

    return true;
  }

  // Retry until InstafeedAPI is available
  if (!override()) {
    var interval = setInterval(function () {
      if (override()) clearInterval(interval);
    }, 200);
    setTimeout(function () { clearInterval(interval); }, 15000);
  }
})();
